<template>
  <div class="clientHelpPage">
    网站教程链接 <br>
    小白也能看懂的量贩皮套导入，从下载到设置表情详细流程：BV13a4y1Q7bh <br>
    VTS小白使用教程：BV1kz4y1q7Ww <br>
    如何设置vts头像+名字教程：BV16v4y1n7XN <br>
    身体万能配挂件，飞头蛮制作方式：BV1Jh4y1x7Ez <br>
    直播姬等设置面补教程：BV1Ez4y177cY <br>
    挂件不贴合怎么办教程：BV1KV4y187AT <br>
    vts一建替换挂件教程：BV1Wm4y1u7pC <br>
    头发+眼睛等纹理集调色教程：BV1aw411D7hS <br>
    <br>
    <div class="line"></div>
    <br>
    本店付费产品包安装，详情加企鹅群：<br>
    🌸群1：835853099(满了请加群3)🌸<br>
    🌸群2：832343224(满了请加群3)🌸<br>
    🌸群3：658892699🌸<br>
    ❤️着急人工电话热线拨打：13253397662（没打通短信留言，一小时内回）<br>
    <br>
    <div class="line"></div>
    <br>
    个人鸣谢（不分先后）<br>
    @xfgryujk：https://space.bilibili.com/300474<br>
    @兔宝的神奇口袋：https://space.bilibili.com/476708774<br>
    @宵夜97：https://space.bilibili.com/1306433<br>
    @只熊KUMA：https://space.bilibili.com/12236936<br>
    @椅子_Official：https://space.bilibili.com/2046120<br>
    <br>
    <div class="line"></div>
    <br>
    ·本插件基于xfgryujk大佬制作，感谢开源组件（网站）提供的灵感材料。<br>
    ·本插件仅限于（小FA朵实验室）插件相关使用，其他相关可能无法匹配使用。<br>
  </div>
</template>

<script>
export default {
  name: "clientHelp"
}
</script>

<style scoped lang="less">
.clientHelpPage {
  padding: 20px;
  font-size: 16px;
  color: #7a97bd;

  .line {
    width: 100%;
    height: 1px;
    background: #7a97bd;
  }
}
</style>
